import React, { useState } from "react"
import AppChangerMenu from "./AppChangerMenu"
import { Link } from "react-router"
import LogoSvg from "@/assets/images/logo-short.svg?react"
import UserMenu from "./UserMenu"
import { Button } from "@/components/ui/button"
import { store } from "@/stores/stores"
import { toast } from "sonner"
import { Tooltip } from "@/components/ui/tooltip"

function Header() {
  const [isLoading, setIsLoading] = useState(false)

  return (
    <div
      className="fixed w-screen top-0 flex h-[var(--header-height)] items-center justify-between bg-background px-2 pr-3 z-11"
      style={{ boxShadow: "0 2px 7px rgba(33,36,41,.14)" }}
    >
      <div className="flex flex-nowrap items-center gap-2">
        <AppChangerMenu />
        <Link to="/" className="flex items-center">
          <LogoSvg className="h-10 w-10 [&_path]:fill-primary" />
        </Link>
        {/* <a
          onClick={() => {
            setModal(<SearchHeader onClose={() => setModal(null)} />)
          }}
          style={{ cursor: "text" }}
        >
          <div className={styles.search_mock}>
            <i className="fal fa-search"></i>
            <span>Pesquisar no Hado</span>
          </div>
        </a> */}
      </div>
      <div></div>
      <div className="flex items-center gap-4">
        {/* <Tooltip tip="Reload nodes">
          <Button
            variant="ghost"
            className="rounded-full size-10"
            loading={isLoading}
            onClick={() => {
              setIsLoading(true)
              store.scenario.actions
                .reloadNodes()
                .then(() => {
                  toast.success("Nodes recarregados com sucesso.")
                  store.scenario.actions.getNodeDefinition()
                })
                .finally(() => {
                  setIsLoading(false)
                })
            }}
          >
            <IconHugeiconsDatabaseSync01 className="size-6" />
          </Button>
        </Tooltip> */}
        <UserMenu />
      </div>
    </div>
  )
}

export default Header
